import React, { useEffect, useState } from "react";
import RoundButton from "../../../Common/RoundButton";
import { useHistory } from "react-router-dom";
import {
  
  Dialog,
  DialogContent,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Box from '@mui/material/Box';
import { getMobileNo, setUserDetails } from "../../../utils/localStorage";
import ErrorMessage from "../../../Common/ErrorMessage";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import useTimer from "../../../Hook/useTimer";
import { confirmOTPRequest } from "../Auth/Login/actionLogin";
import { Field, Form, Formik } from "formik";
import { InputType } from "../../../Common/FormFields/InputType";

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: "flex-end", // push the dialog to bottom
  },
  paper: {
    // make the content full width
    margin: 0,
    maxWidth: "100%",
    width: "100%",
  },
}));

const LDCOTP = (props: any) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { seconds, setSeconds } = useTimer(30);
  const [errorMessage, setErrorMessage] = useState("");
  const [verifyingOTP, setVerifyingOTP] = useState(true);
  const { loginError, confirmOTPResponse } = useSelector(
    (state: any) => state.login
  );
  useEffect(() => {
    if (confirmOTPResponse?.results?.response?.user_id) {
      setUserDetails(JSON.stringify(confirmOTPResponse?.results));
      history.push({
        pathname: "/p2p/legalAuth",
      });
    }
    if(confirmOTPResponse?.results){
      if (confirmOTPResponse?.results?.message === "wrong OTP" || Object.keys(confirmOTPResponse?.results?.response).length == 0) {
        setErrorMessage(confirmOTPResponse?.results?.message);
      }
    }
    setVerifyingOTP(!verifyingOTP);
  }, [confirmOTPResponse]);

  const initialValues = {
    phone: getMobileNo(),
    otp_1: "",
    otp_2: "",
    otp_3: "",
    otp_4: "",
    otp_5: "",
    otp_6: ""
  };

  const validationSchema = () =>
    Yup.object().shape({
      otp_1: Yup.string()
        .required("*Required")
        .max(1, "Please enter a valid otp")
        .min(1, "Please enter a valid otp"),
      otp_2: Yup.string()
        .required("*Required")
        .max(1, "Please enter a valid otp")
        .min(1, "Please enter a valid otp"),
      otp_3: Yup.string()
        .required("*Required")
        .max(1, "Please enter a valid otp")
        .min(1, "Please enter a valid otp"),
      otp_4: Yup.string()
        .required("*Required")
        .max(1, "Please enter a valid otp")
        .min(1, "Please enter a valid otp"),
      otp_5: Yup.string()
        .required("*Required")
        .max(1, "Please enter a valid otp")
        .min(1, "Please enter a valid otp"),
      otp_6: Yup.string()
        .required("*Required")
        .max(1, "Please enter a valid otp")
        .min(1, "Please enter a valid otp"),
    });

  const onSubmitHandle = (value: any) => {
    value.otp = "";
    Object.keys(value).map((inputkey: any) => {
      if (
        inputkey === "otp_1" ||
        inputkey === "otp_2" ||
        inputkey === "otp_3" ||
        inputkey === "otp_4" ||
        inputkey === "otp_5" ||
        inputkey === "otp_6"

      )
        value.otp += value[inputkey];
    });
    setVerifyingOTP(!verifyingOTP);
    dispatch(confirmOTPRequest(value.otp));
  };

  const onChangeOtp = () => { };

  const resendOTP = () => {
    const phone = getMobileNo();
    if (!phone || seconds > 0) return false;
    const data = {
      phone,
    };
    setSeconds(30);
  };

  const focusChange = (e: any) => {
    if (
      e.target.value.length >= e.target.getAttribute("maxlength") &&
      e.target.nextElementSibling
    )
      e.target.nextElementSibling.focus();

    if (e.keyCode && e.keyCode === 8 && e.target.previousElementSibling) {
      e.target.previousElementSibling.focus();
      setErrorMessage("");
    }
  };

  const checkError = (errors: any) => {
    if (Object.values(errors).length > 0)
      return <ErrorMessage text="*Required" />;
  };

  return (
    <Box className="otp-dialog">
      <Dialog
        open={props.toggle}
        onClose={props.handleClose}
        onEnter={props.openOTPDialog}
        classes={{ container: classes.root, paper: classes.paper }}
      >
        <DialogContent>
          <Box className="contentArea terms-otp">
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(value) => onSubmitHandle(value)}
            >
              {({ handleSubmit, values, touched, errors }) => (
                <Form>
                  <div>
                    <div>
                      <Box className="optInbutBox">
                        <Field
                          component={InputType}
                          type="number"
                          name="otp_1"
                          maxLength={1}
                          onKeyUp={(e: any) => focusChange(e)}
                          value={values.otp_1}
                          onChange={onChangeOtp}
                          backgroundcolor="#ffffff"
                          showerror="false"
                        />
                        <Field
                          component={InputType}
                          type="number"
                          name="otp_2"
                          maxLength={1}
                          onKeyUp={(e: any) => focusChange(e)}
                          value={values.otp_2}
                          onChange={onChangeOtp}
                          backgroundcolor="#ffffff"
                          showerror="false"
                        />
                        <Field
                          component={InputType}
                          type="number"
                          name="otp_3"
                          maxLength={1}
                          onKeyUp={(e: any) => focusChange(e)}
                          value={values.otp_3}
                          onChange={onChangeOtp}
                          backgroundcolor="#ffffff"
                          showerror="false"
                        />
                        <Field
                          component={InputType}
                          type="number"
                          name="otp_4"
                          maxLength={1}
                          onKeyUp={(e: any) => focusChange(e)}
                          value={values.otp_4}
                          onChange={onChangeOtp}
                          backgroundcolor="#ffffff"
                          showerror="false"
                        />
                        <Field
                          component={InputType}
                          type="number"
                          name="otp_5"
                          maxLength={1}
                          onKeyUp={(e: any) => focusChange(e)}
                          value={values.otp_5}
                          onChange={onChangeOtp}
                          backgroundcolor="#ffffff"
                          showerror="false"
                        />
                        <Field
                          component={InputType}
                          type="number"
                          name="otp_6"
                          maxLength={1}
                          onKeyUp={(e: any) => focusChange(e)}
                          value={values.otp_6}
                          onChange={onChangeOtp}
                          backgroundcolor="#ffffff"
                          showerror="false"
                        />
                      </Box>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          color: "#f80028",
                        }}
                      >
                        {errorMessage}
                      </Box>
                      {checkError(errors)}
                      <p
                        className="fs-16 fw-600 text-center"
                        style={{
                          cursor: seconds === 0 ? "pointer" : "default",
                        }}
                        onClick={() => resendOTP()}
                      >
                        {seconds > 0
                          ? `Resend OTP in ${seconds}`
                          : "Resend OTP"}
                      </p>
                    </div>
                  </div>
                  <Box sx={{ mt: 5, mb: 6.2 }}>
                    <Typography
                      component="p"
                      className="fs-12 text-dark"
                      align="center"
                    >
                      We have sent <strong className="fw-600">OTP</strong> to
                      your mobile number{" "}
                      <strong className="fw-600">{getMobileNo()} </strong>
                      to accept the terms and conditon fo{" "}
                      <strong className="fw-500">
                        stashearn and Lendenclub
                      </strong>
                    </Typography>
                  </Box>
                  <div style={{ marginBottom: "20px" }}>
                    <RoundButton
                      title="Verify OTP"
                      type="submit"
                      disable={verifyingOTP}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default LDCOTP;